module.exports = __webpack_public_path__ + "static/media/2-3-1_OPP_Glossy_02.00e8a594.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/2-3-1_OPP_Glossy_02.jpg
// module id = 1720
// module chunks = 0